<ng-container *transloco="let translate">
  <div fxFlex="15" fxLayout="column">
    <div class="heading" fxFlex="100">{{ offer.shipmentStationAddress.name }}</div>
    <div class="offer__date-time" fxFlex="100">
      <span class="date">
        {{ offer.shipmentStationAddress.date | egDate }}
      </span>
      <span class="time">
        {{ offer.shipmentStationAddress.date | egDate: 'time' }}
      </span>
    </div>
  </div>

  <div fxFlex="7" fxLayout="column">
    <img class="destination-separator" src="/assets/icons/arrows/next.svg" alt="NEXT" />
  </div>

  <div fxFlex="23" fxLayout="column">
    <div class="heading" fxFlex="100">
      {{ offer.destinationStationAddress.name }}
    </div>
    <div class="offer__date-time" fxFlex="100">
      <span class="date">
        {{ offer.destinationStationAddress.date | egDate }}
      </span>
      <span class="time">
        {{ offer.destinationStationAddress.date | egDate: 'time' }}
      </span>
    </div>
  </div>

  <div [fxFlex]="offer.special ? 12 : 14" fxLayout="column">
    <div class="heading" fxFlex="100">{{ deliveryDateText }}</div>
    @if (offer.category === 'IMPORT') {
      <div class="offer__date-time" fxFlex="100">
        <span class="date">
          {{ offer.earliestDelivery | egDate }}
        </span>
        <span class="time">
          {{ offer.earliestDelivery | egDate: 'time' }}
        </span>
      </div>
    }
    @if (offer.category !== 'IMPORT') {
      <div class="offer__date-time" fxFlex="100">
        <span class="date">
          {{ offer.cutoff | egDate }}
        </span>
        <span class="time">
          {{ offer.cutoff | egDate: 'time' }}
        </span>
      </div>
    }
  </div>
  @if (offer.special) {
    <div fxFlex="2">
      <img
        src="/assets/icons/star.svg"
        [ngClass]="{
          'svg-to-warning': offer.special === 'TRAIN',
          'svg-to-error': offer.special?.indexOf('DISCOUNT') > 0,
          hidden: offer.special === 'PLATFORM' || offer.special === 'TARIFF',
        }"
        alt="Special train"
        [egTooltip]="
          offer.special === 'TRAIN'
            ? translate('routeSelection.offers.specialTrain')
            : offer.special?.indexOf('DISCOUNT')
              ? translate('routeSelection.offers.specialDiscount')
              : null
        "
      />
    </div>
  }

  <div fxFlex="9" fxLayout="row" fxLayoutAlign="space-around center" class="capacity-indicator pointer">
    <img
      src="/assets/icons/offer_{{ offer.status.toLowerCase() }}.svg"
      alt="{{ offer.status }}"
      [egTooltip]="translate('offerStatus.' + offer.status)"
    />
    @if (offer.eco) {
      <img src="/assets/icons/trip_eco.svg" alt="ECO" />
    }
    @if (!offer.truckingAvailable) {
      <img
        egTooltip="{{ translate('routeSelection.offers.noTrucking') }}"
        src="/assets/icons/disabled_truck.svg"
        class="no-trucking"
        alt="No trucking"
      />
    }
  </div>

  <div fxFlex="13" fxLayout="column" fxLayoutAlign="end start">
    @if (!(offer?.special === 'TRAIN' && offer?.startingPrice?.amount === 0)) {
      <span class="subheading" fxFlex="100">{{ translate('from') }}</span>
      <span class="heading pr-20" fxFlex="100"
        >{{ offer.startingPrice.amount | egNumber: '0.2-2' }} {{ offer.startingPrice.currency | egCurrencySymbol }}</span
      >
    }
  </div>

  @if (showCo2) {
    <div fxFlex="8" fxLayout="column" fxLayoutAlign="center">
      <span class="subheading" fxFlex="100">{{ translate('routeSelection.offers.co2') }}</span>
      <span class="heading pr-20" fxFlex="100">{{ offer.co2Emission }} kg</span>
    </div>
  }
  @if (!bookingButtonHidden) {
    <div
      [egTooltip]="!disableBookingRules && offer?.status === 'BOOKED' ? translate('routeSelection.offers.noCapacity') : null"
      fxFlex="5"
      fxLayout="column"
    >
      <button
        [disabled]="!disableBookingRules && disableBooking"
        [ngClass]="[
          !disableBookingRules ? 'book-button mr-16 book-button__' + offer?.status : 'book-button mr-16',
          changeRoutingLoading ? 'flex flex-jc-center flex-ai-center flex-gap-100' : '',
        ]"
        [class.book-button--rebooking]="rebooking"
        (click)="bookingButtonClicked.emit(offer)"
      >
        @if (changeRoutingLoading) {
          <eg-spinner [size]="10"></eg-spinner>
        }
        <span>{{ bookingButtonText }}</span>
      </button>
    </div>
  }
</ng-container>
